// extracted by mini-css-extract-plugin
export default {"noAccess":"noAccess_noAccess__b0j50"};